module.exports = __webpack_public_path__ + "static/fourth-3bb59bee4d44f955c4779b420700ef4d.jpg";